import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { PostMessageService } from '../../services/post-message.service';
import { HttpContextToken } from '@angular/common/http';
import { environment } from '@/environments/environment';

/**
 * Interceptor HTTP funcional que agrega el token de autenticación
 * a todas las peticiones salientes.
 *
 * El token se obtiene desde el PostMessageService, que lo recibe
 * desde la aplicación padre vía postMessage.
 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_AUTH)) {
    return next(req);
  }

  const postMessageService = inject(PostMessageService);
  const token = postMessageService.getAccessToken();

  // Si no hay token, continuar sin modificar la petición
  if (!token) {
    console.warn('[AuthInterceptor] No hay token disponible');
    return next(req);
  }

  // Clonar la petición y agregar el header de autorización
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  !environment.production &&
    console.log('[AuthInterceptor] Token agregado a la petición:', req.url);
  return next(authReq);
};
